import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const serviceApi = createApi({
  reducerPath: "serviceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL, //  "http://localhost:3095/api/v1"
  }),
  endpoints: (builder) => ({
   
    LocationCodeVerify: builder.mutation({
      query: (data) => ({
        url: "/vendor/location-code-verify",
        method: "POST",
        body: data,
        //  headers: {
        //   "Accept": "application/json"
        // }
      }),
    }),
    AddServiceManagement: builder.mutation({
      query: (data) => ({
        url: "/vendor/add-service-management",
        method: "POST",
        body: data,
         headers: {
          "Accept": "application/json"
        }
      }),
    }),
   
   
    
  }),
});

export const {
    useLocationCodeVerifyMutation,
    useAddServiceManagementMutation
} = serviceApi;
